var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.414 17.414",
    stroke: "#263360"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-1333.293 -241.785)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 16,
    y2: 16,
    transform: "translate(1334 242.492)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 16,
    y2: 16,
    transform: "translate(1334 242.492)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
};
export default SvgCancel;